import { useEffect, useReducer, useState } from "react";
// TODO remove @material-ui
import Box from "@material-ui/core/Box";
import { API_URL, postApi } from "@cti-workspace/helpers";
import DefaultView from "./DefaultView";
// import ErrorView from "./ErrorView";
// import LoadView from "./LoadView";
import RenderLoadView from "./RenderLoadView";
import FrameView from "./FrameView";

const initialState = { value: "default", payload: "" };

const reducer = (state, action) => {
	switch (action.type) {
		case "setLoading":
			return { value: "loading" };
		case "setFileReadSuccess":
			return { value: "fileReadSuccess", payload: action.payload };
		case "setFileReadFailure":
			return { value: "fileReadFailure", payload: action.payload };
		case "setCallApi":
			return { value: "apiCall", payload: action.payload };
		case "setCallApiFailure":
			return { value: "apiCallFailure" };
		case "setCallApiSuccess":
			return { value: "apiCallSuccess", payload: action.payload };
		case "setDocumentRender":
			return { value: "documentRender", payload: action.payload };
		case "reset":
			return initialState;
		default:
			throw new Error();
	}
};

const Renderer = (props) => {
	const [state, dispatch] = useReducer(reducer, initialState);
	const [document, setDocument] = useState([
		{
			name: "Default document",
			document: {
				foo: {
					title: "Bar is awesome",
				},
				name: "John Doe",
				institute: "Institute of John Doe",
				$template: {
					name: "custom",
					type: "EMBEDDED_RENDERER",
					url: "http://localhost:3000",
				},
			},
		},
	]);

	const [rawDocument, setRawDocument] = useState({});
	const [documentStatus, setDocumentStatus] = useState("valid");

	const verifier = async (doc, forceVerify) => {
		if (!props.preview) {
			try {
				// progressStart();
				setRawDocument(doc);
				if (!props.usedNewApi || forceVerify) {
					dispatch({ type: "setLoading" });
					await postApi(`/public/verifyCert`, { ...doc }, {}, false, API_URL);
					let error = false;
					if (error) {
						setDocumentStatus("invalid");
					} else {
						// console.log("file",doc)
						setDocumentStatus("valid");
					}
					dispatch({ type: "setCallApiSuccess" });
					// console.log(data);
				}

				setDocument(doc.vc);
			} catch (err) {
				setDocumentStatus("invalid");
				dispatch({ type: "setCallApiSuccess" });
				setDocument(doc.vc);
				console.error(err);
			}
		} else {
			dispatch({ type: "setLoading" });
			setDocumentStatus("valid");
			dispatch({ type: "setCallApiSuccess" });
			setRawDocument(doc);
			if (doc?.vc) setDocument(doc?.vc);
		}
	};

	useEffect(() => {
		(async () => {
			if (props.requestedDoc) {
				await verifier(props.requestedDoc);
				dispatch({ type: "setDocumentRender" });
			}
		})();
	}, [props.requestedDoc]);

	// console.log(state.value);

	return (
		<Box fullWidth style={{ paddingTop: "1rem", height: "100%", width: "100%" }}>
			{
				documentStatus === "valid" ? (
					state.value === "documentRender" ? (
						<FrameView
							componentRef={props.componentRef}
							setIsDraft={props.setIsDraft}
							rawDocument={rawDocument}
							document={document}
							setFullFrame={props.setFullFrame}
							certState={props.certState}
							additionalDataMain={props.additionalDataMain}
							creExpiredText={props.creExpiredText}
							locale={props.locale}
							showBadge={props.showBadge}
							getBadgeUrl={props.getBadgeUrl}
							setPrintPageSize={props.setPrintPageSize}
							setCertBgImg={props.setCertBgImg}
							setFabricPageNames={props.setFabricPageNames}
							activePageName={props.activePageName}
							fabricCertiFullPageRef={props.fabricCertiFullPageRef}
							downloadPdf={props.downloadPdf}
							usedNewApi={props.usedNewApi}
							renderConfig={props.renderConfig}
              theme={props.theme}
              isCertValid={props.isCertValid}
              fallbackBackgroundImg={props.fallbackBackgroundImg}
						/>
					) : state.value === "loading" ? (
						!props.showContainer ? (
							<RenderLoadView color={props?.theme && props?.theme?.primaryColor} />
						) : null
					) : // <LoadView />
					props.showContainer ? (
						<DefaultView />
					) : null
				) : null
				// <ErrorView errorInfo={errorState} />
			}
			{/* {showVerificationResultsDialog && <BulkVerificationResult onClose={() => setShowVerificationResultsDialog(false)} data={verifiedCredentialsData} objLinks={objVerifyLink} />} */}
			<div style={{ padding: "0.5rem" }} />
			{/* <CertificateBadgeSwitch /> */}
		</Box>
	);
};

export default Renderer;
